"use client";

import { MapPin, Phone, MessageCircle, Mail } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Link } from "@/components/common/Link";
export default function Ubicacion() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const contactItems = [{
    icon: Phone,
    label: "Teléfono",
    value: "+34 123 456 789",
    href: "tel:+34123456789",
    external: false
  }, {
    icon: MessageCircle,
    label: "WhatsApp",
    value: "+34 123 456 789",
    href: "https://wa.me/34123456789",
    external: true
  }, {
    icon: Mail,
    label: "Email",
    value: "reservaciones@mareamezcal.com",
    href: "mailto:reservaciones@mareamezcal.com",
    external: false
  }, {
    icon: MapPin,
    label: "Dirección",
    value: "Playa del Carmen, Quintana Roo, México",
    href: "https://maps.google.com/?q=Playa+del+Carmen+Quintana+Roo+México",
    external: true
  }];
  return <section id="ubicación" ref={sectionRef} className="py-[72px] px-6 bg-background">
      <div className="max-w-7xl mx-auto">
        <div className={`grid lg:grid-cols-2 gap-12 items-start transition-all duration-[var(--duration-slow)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {}
          <div className="w-full h-[500px] rounded-lg overflow-hidden shadow-medium">
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3037.6261837451!2d-3.7037902!3d40.4167754!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNDDCsDI1JzAwLjQiTiAzwrA0MicxMy42Ilc!5e0!3m2!1sen!2ses!4v1234567890123!5m2!1sen!2ses" width="100%" height="100%" style={{
            border: 0
          }} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="Ubicación en mapa" />
          </div>

          {}
          <div className="flex flex-col gap-8">
            <div>
              <h2 className="font-display text-4xl lg:text-5xl font-bold text-foreground mb-4">
                Visítanos
              </h2>
              <p className="text-muted-foreground text-lg font-sans font-normal">
                Encuentra nuestra ubicación y ponte en contacto con nosotros
              </p>
            </div>

            <div className="flex flex-col gap-6">
              {contactItems.map((item, i) => {
              const Icon = item.icon;
              return <Link key={i} data-index={i} to={item.href} newTab={item.external} className="flex items-start gap-4 p-6 bg-muted rounded-lg border border-border transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] hover:translate-x-1 hover:shadow-soft group">
                    <div className="flex-shrink-0 w-12 h-12 rounded-full bg-accent/10 flex items-center justify-center transition-all duration-[var(--duration-medium)] group-hover:bg-accent/20">
                      <Icon className="size-6 text-accent-dark transition-all duration-[var(--duration-medium)]" />
                    </div>
                    <div className="flex-1">
                      <div className="text-sm font-semibold text-muted-foreground mb-1 font-sans">
                        {item.label}
                      </div>
                      <div className="text-base font-normal text-foreground font-sans group-hover:text-accent-dark transition-all duration-[var(--duration-medium)]">
                        {item.value}
                      </div>
                    </div>
                  </Link>;
            })}
            </div>
          </div>
        </div>
      </div>
    </section>;
}